import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

import { AlarmSource, AlarmSourceType, AlarmSeverity } from '@/server/MakeSenseApp-backend'



export default /*@__PURE__*/_defineComponent({
  __name: 'AlarmSourcesCell',
  props: {
  alarmSources: Array<AlarmSource>
},
  setup(__props) {



function renderType(type?: AlarmSourceType) {
  if (type === AlarmSourceType.SpareParts) {
    return 'Inventory'
  }

  return type
}

function tagSeverityToBadgeClass(severity?: AlarmSeverity) {
  if (severity === undefined) {
    return
  }
  switch (severity) {
    case AlarmSeverity.LowSeverity:
      return 'secondary'
    case AlarmSeverity.MediumSeverity:
      return 'warning'
    case AlarmSeverity.HighSeverity:
      return 'danger'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.alarmSources, (source, index) => {
    return (_openBlock(), _createElementBlock("span", {
      key: index,
      class: _normalizeClass('badge text-bg-' + tagSeverityToBadgeClass(source.severity) + ' ms-badge')
    }, _toDisplayString(renderType(source.type)), 3))
  }), 128))
}
}

})